module.exports = __webpack_public_path__ + "/build/web/images/matching-pillows@3x.63b1be2b4823b777845332f3bbf0acd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/matching-pillows@3x.jpg
// module id = 175
// module chunks = 13